/*
Monotype Foundry Platform API
Version 1.0.0

Definition: PackageSuggestionResponse

Properties:
  packages: array
  success: boolean
*/

var PackageSuggestionResponse = (function () {
  function validatePackageSuggestionResponse (arg) {
    // Validate packages
    if (arg.packages && !(Array.isArray(arg.packages))) {
      throw new Error('PackageSuggestionResponse.packages: Wrong type: Got \'' + (typeof arg.packages) + '\', but expected: \'array\'')
    }
    // Validate success
    if (arg.success && !(typeof arg.success === 'boolean')) {
      throw new Error('PackageSuggestionResponse.success: Wrong type: Got \'' + (typeof arg.success) + '\', but expected: \'boolean\'')
    }
  }
  function buildPackageSuggestionResponse (arg) {
    var PackageSuggestionResponse = arg
    // Complete packages
    // Expected Type: array
    PackageSuggestionResponse.packages = PackageSuggestionResponse.packages || []
    // Complete success
    // Expected Type: boolean
    PackageSuggestionResponse.success = PackageSuggestionResponse.success || false
    return PackageSuggestionResponse
  }
  return {
    validate: validatePackageSuggestionResponse,
    build: buildPackageSuggestionResponse
  }
})()

module.exports = PackageSuggestionResponse
